import { custom } from '@carboledger/ui';
import {
  referenceIdNumberRule,
  positiveNumberRule,
  percentageRule,
  signedNumberRule,
} from '@/lib/validation';
import { getTranslation } from '@/lib/utils/i18n';
import { GHG_DEFAULT_VALUE } from './constants/validateDeclaration.constants';
import { ghgTotalMatchesBreakdown } from './utils/declarationsUtils';

// Only enforced when the RED III default value isn't applied — otherwise the breakdown is hidden.
const ghgTotalMatchesBreakdownRule = custom(
  (value, values) =>
    values.defaultGhgValueApplied !== GHG_DEFAULT_VALUE.no ||
    ghgTotalMatchesBreakdown(value, values),
  getTranslation('VALIDATION_GHG_TOTAL_MISMATCH'),
);

// Format rules for <ValidateDeclarationForm>, keyed by field name; `required` lives on each <Field>.
export const declarationValidation = {
  idNumber: referenceIdNumberRule,
  quantity: positiveNumberRule,
  energyContent: positiveNumberRule,
  totalGhgEmissions: [...signedNumberRule, ghgTotalMatchesBreakdownRule],
  // Mandatory selection — `custom(Boolean, …)` fails on an empty value (mirrors densityRequiredRule).
  escaBonusCap: [custom(Boolean, getTranslation('VALIDATION_ESCA_BONUS_CAP_REQUIRED'))],
  eec: signedNumberRule,
  el: signedNumberRule,
  ep: signedNumberRule,
  etd: signedNumberRule,
  eu: signedNumberRule,
  escaValue: signedNumberRule,
  eccs: signedNumberRule,
  eccr: signedNumberRule,
  allocatedHeat: positiveNumberRule,
  allocatedElectricity: positiveNumberRule,
  // The five saving fields are percentages — the inputs carry a % suffix.
  biofuelsForTransportSaving: percentageRule,
  bioliquidsElectricitySaving: percentageRule,
  biomassOutermostRegionsSaving: percentageRule,
  bioliquidsHeatSaving: percentageRule,
  biomassCoalSubstitutionSaving: percentageRule,
};
